import { useEffect, useRef, useState } from 'react';
import { salesOrderUpload } from 'Service/ApiService';
// import { checkGeolocationStatus } from 'utils/constants';
// import { getLocation } from 'utils/constants';
import { showAlert, showAlertLong } from 'utils/ErrorMessage';
import { showSuccessAlert } from 'utils/SuccessMessage';

const SalesOrderUploadController = () => {
  // const locationData = localStorage.getItem("location");
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  // const[severity,setseverity] = useState();
  // const[message,setmessage] = useState();
  // const[alert,setAlert] = useState(false);

  useEffect(() => {
    // if (!locationData) {
    //   getLocation();
    // }
  }, []);

  // const getLocationData = () => {
  //   const locationData = localStorage.getItem('location');
  //   return locationData ? JSON.parse(locationData).address : "";
  // };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const fileExtension = file.name.split('.').pop().toLowerCase();
    // console.log("fileExtension",fileExtension)
    if (fileExtension === 'csv') {
      const now = new Date();
      const date = now.toLocaleDateString('en-CA'); // Format: YYYY-MM-DD
      const time = now.toLocaleTimeString('en-GB').replace(/:/g, '-'); // Format: HH-MM-SS

      const newFileName = `SalesUpload_${date}_${time}.csv`;

      // Create a new file with the desired name
      const newFile = new File([file], newFileName, { type: file.type });

      setSelectedFile(newFile);
    } else {
      event.target.value = ''; // Clear the file input
      setSelectedFile(null);
      clearFileInput(); // Clear the selected file state
      showAlert('Please upload a CSV file', 'Validation');
    }
  };

  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset the value of the file input
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    try {
      // setAlert(false);
      if (selectedFile) {
        setLoading(true);

        //const location = await getLocationData();
        // console.log("Location",location)
        try {
          const response = await salesOrderUpload(selectedFile);
          // console.error('Return Response:', response);
          if (response && response.success === 'true') {
            showSuccessAlert(response.msg, 'Message');
            // setmessage(response.msg);
            // setseverity("green");
            // setAlert(true);
          } else {
            showAlertLong(response.msg, 'Validation');
            // setmessage(response.msg);
            // setseverity("red");
            // setAlert(true);
          }
        } catch (error) {
          // console.error('Error during upload:', error);
          showAlert('An error occurred during the upload', 'error');
        } finally {
          setLoading(false);
          setTimeout(() => {
            setSelectedFile(null);
            clearFileInput();
            // setAlert(false);
          }, 3000);
        }

        // else{
        //   const geolocationStatus = await checkGeolocationStatus();
        //           if (geolocationStatus) {
        //             await getLocation();
        //           } else {
        //             showAlert('Please enable location services', 'error');
        //             setLoading(false);
        //             return;
        //           }
        // }
      } else {
        showAlert('Please select a file to upload', 'Validation');
        // setmessage("Please select a file to upload");
        // setseverity("red");
        // setAlert(true);
      }
    } catch (error) {
      setLoading(false);
      // console.error('Error during login:', error);
    }
  };

  return {
    loading,
    handleFileChange,
    handleUpload,
    fileInputRef
    // severity,
    // message,
    // alert,
  };
};

export default SalesOrderUploadController;
